// extracted by mini-css-extract-plugin
export default {"buttonGroup":"main-buttonGroup_OJWJa"};